import Vue from 'vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';

@Component({
    data() {
        return {
            holderName: null,
            immediateValidation: false
        };
    },
    components: {
        ValidationProvider
    },
    inheritAttrs: false
})
export default class CardHolder extends Vue {
    @Ref() readonly provider!: InstanceType<typeof ValidationProvider>;

    @Prop()
    value: string;

    @Prop()
    label: string;

    @Prop()
    placeholder: string;

    @Prop({ default: 'cardHolder' })
    inputName: string;

    @Prop()
    validationMode:string;

    @Prop({ type: String, default: '#06A9BF' })
    checkColor: string;

    holderName: string;
    immediateValidation: boolean;

    created() {
        this.holderName = this.value;
    }

    formatHolderName() {
        if (!this.holderName) {
            return;
        }

        this.holderName = this.holderName.trim();
    }

    @Watch('holderName')
    change(value, oldValue) {
        this.$emit('input', value);
    }

    @Watch('value', { immediate: true })
    onChangeValue(value: string) {
        if (value?.length > 0) {
            this.immediateValidation = true;
        }
    }
}
